import React, { Component } from 'react';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import CreatableSelect from 'react-select/creatable';
import SweetAlert from 'react-bootstrap-sweetalert';
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";

var redirectURL = require('../redirectURL');

// TRANSPORTER CHILD CODES - one configuration screen for the whole TAB.
//
// Deliberately NOT an edit action on the transporters grid. A transporter is held as many rows
// (one per state / zone / vehicle type) but its child codes belong to the TRANSPORTER, so a pencil
// on every row reads as "set these again for each row", which is the wrong idea. This grid lists
// each LSP ONCE with its codes, and a save writes to all of that transporter's rows on the tab.
//
// Free entry is correct HERE - this screen IS the master, MSIL supplies the codes. The Actual SOB
// configuration then PICKS from this list instead of asking for free text, which is the whole
// point of defining them here.

// Accepts a typed code or a pasted list (comma / newline / semicolon / space separated), keeps
// what is already there, upper-cases and de-duplicates.
function mergeCodes(current, input) {
    var out = (current || []).slice();
    String(input || "").split(/[,;\s]+/).forEach(function (raw) {
        var code = String(raw || "").trim().toUpperCase();
        if (code && out.indexOf(code) < 0) { out.push(code); }
    });
    return out;
}

export default class TransporterChildCodesModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: [],                 // [{transporter_code, transporter_name, child_codes[], row_count}]
            editing: null,            // the row being edited, null when none
            draft: [],                // its codes, before Save
            typed: "",                // what is typed in the chip input, before Enter
            saving: false,            // a save is in flight - further clicks on Save are ignored
            loadshow: 'show-n',
            show: false,
            basicTitle: "",
            basicType: "default"
        };
    }

    componentDidMount() {
        if (this.props.open) { this.loadRows(); }
    }

    componentDidUpdate(prev) {
        if (this.props.open && !prev.open) { this.loadRows(); }
        else if (this.props.open && (prev.dataType !== this.props.dataType
                                     || prev.hubTransporter !== this.props.hubTransporter
                                     || prev.airCourierTransporter !== this.props.airCourierTransporter
                                     || prev.loadingPortCode !== this.props.loadingPortCode)) {
            this.loadRows();
        }
    }

    tabParams() {
        return {
            loading_port_code: this.props.loadingPortCode,
            data_type: this.props.dataType,
            hub_transporter: this.props.hubTransporter ? 1 : 0,
            air_courier_transporter: this.props.airCourierTransporter ? 1 : 0
        };
    }

    // Read from the server rather than from the transporters grid: that grid shows one row per
    // state / vehicle type, while this is one row per transporter, and the endpoint unions the
    // codes of a transporter whose rows disagree (possible on data written before this screen).
    loadRows() {
        var self = this;
        this.setState({ loadshow: 'show-m', editing: null, draft: [], typed: "" });
        redirectURL.post("/lmconsignees/getTransporterChildCodes", this.tabParams())
            .then(function (r) {
                self.setState({ rows: (r.data && r.data.records) || [], loadshow: 'show-n' });
            })
            .catch(function (e) {
                self.setState({ loadshow: 'show-n', show: true, basicType: "danger",
                                basicTitle: "Could not read the child codes: " + e.message });
            });
    }

    // Turn whatever is typed into a chip. Returns true when it consumed the keystroke, so Enter
    // does not also submit while the user is still adding codes. The menu is suppressed (there is
    // nothing to pick from), and with no menu react-select has no "Create ..." option for Enter to
    // commit - so the typed text is held here and committed on Enter / Tab / comma / blur.
    commitTyped() {
        var text = this.state.typed || "";
        if (String(text).trim() === "") { return false; }
        this.setState({ draft: mergeCodes(this.state.draft, text), typed: "" });
        return true;
    }

    saveRow() {
        var self = this;
        var row = this.state.editing;
        if (!row) { return; }
        // One save at a time - the edit dialog sits above the loader, so a second click on Save
        // would otherwise post the same save again while the first is still in flight.
        if (this.state.saving) { return; }
        // Commit anything still in the input, so a code typed but not Entered is not discarded by
        // the save the user just clicked.
        var codes = this.state.typed && String(this.state.typed).trim() !== ""
                  ? mergeCodes(this.state.draft, this.state.typed)
                  : this.state.draft;
        // A transporter with NO child code can never be resolved from the feed - every dispatch of
        // it comes back "LSP Missing" and its volume is dropped from actual SOB silently. So an
        // empty list is refused here, and refused again on the server.
        if (codes.length === 0) {
            this.setState({ show: true, basicType: "warning",
                            basicTitle: "A transporter must keep at least one child code. Remove "
                                      + "the transporter itself if it no longer despatches." });
            return;
        }
        this.setState({ loadshow: 'show-m', saving: true });
        var payload = Object.assign(this.tabParams(), {
            transporter_code: row.transporter_code,
            child_codes: codes,
            email: localStorage.getItem("email") || "",
            user_name: localStorage.getItem("username") || "",
            staff_id: localStorage.getItem("staff_id") || "",
            comp_code: localStorage.getItem("comp_code") || "",
            user_department: localStorage.getItem("lm_department") || "",
            user_role: localStorage.getItem("roles") || "",
            designation: localStorage.getItem("designation") || ""
        });
        redirectURL.post("/lmconsignees/saveTransporterChildCodes", payload)
            .then(function (r) {
                if (r.data && r.data.status === "success") {
                    var rows = self.state.rows.map(function (x) {
                        return x.transporter_code === row.transporter_code
                             ? Object.assign({}, x, { child_codes: codes }) : x;
                    });
                    self.setState({ loadshow: 'show-n', saving: false, rows: rows, editing: null,
                                    draft: [], typed: "", show: true, basicType: "success",
                                    basicTitle: "Saved on " + (r.data.matched || 0)
                                                + " row(s) of this transporter" });
                    if (self.props.onSaved) { self.props.onSaved(); }
                } else {
                    // A refusal must name WHAT was refused, not just that it was. The commonest
                    // one is a child code already held by another transporter: the server sends
                    // `clashes[]`, which is rendered as one line per code so the user can see
                    // which transporter to take it off, rather than re-reading one long sentence.
                    // Nothing was written server-side, so the list on screen is still the saved
                    // one and the edit dialog stays open for a correction.
                    var clashes = (r.data && r.data.clashes) || [];
                    var title = (r.data && r.data.message) || "Could not save";
                    if (clashes.length > 0) {
                        // `late` = another save claimed the code between the check and this
                        // save's write; this save was put back, so nothing of it is stored.
                        title = (r.data.late
                                    ? "Another save claimed these child codes at the same moment, so "
                                    : "These child codes already belong to another transporter, so ")
                              + "nothing was saved:\n\n"
                              + clashes.map(function (c) {
                                    return "• " + c.child_code + "  →  "
                                         + (c.transporter_name || c.transporter_code)
                                         + " (" + c.transporter_code
                                         + (c.loading_port_code ? ", " + c.loading_port_code : "")
                                         + ")";
                                }).join("\n")
                              + "\n\nA child code can belong to only one transporter - MSIL's feed "
                              + "is resolved to a parent by this list alone. Remove it from the "
                              + "other transporter first, or use a different code.";
                    }
                    self.setState({ loadshow: 'show-n', saving: false, show: true,
                                    basicType: "warning", basicTitle: title });
                }
            })
            .catch(function (e) {
                // A non-2xx carries the server's own reason in the response body; e.message alone
                // is just "Request failed with status code 400", which tells the user nothing.
                var serverMsg = e && e.response && e.response.data && e.response.data.message;
                self.setState({ loadshow: 'show-n', saving: false, show: true, basicType: "danger",
                                basicTitle: "Could not save: " + (serverMsg || e.message) });
            });
    }

    columnDefs() {
        var self = this;
        var readOnly = this.props.readOnly === true;
        return [
            { headerName: "Transporter Name", field: "transporter_name", flex: 1.6, minWidth: 200,
              filter: true, resizable: true },
            { headerName: "Transporter Code", field: "transporter_code", flex: 0.9, minWidth: 130,
              filter: true, resizable: true },
            { headerName: "Transporter Child Codes", field: "child_codes", flex: 2.4, minWidth: 260,
              filter: true, resizable: true, autoHeight: true, wrapText: true,
              valueGetter: function (p) { return ((p.data && p.data.child_codes) || []).join(", "); },
              tooltipValueGetter: function (p) {
                  var codes = (p.data && p.data.child_codes) || [];
                  return codes.length > 0 ? codes.join(", ")
                                          : "No child code defined for this transporter yet";
              },
              cellRenderer: function (p) {
                  var codes = (p.data && p.data.child_codes) || [];
                  return codes.length > 0 ? codes.join(", ")
                       : '<span style="color:#b45309">Not defined</span>';
              } },
            // Rows carrying the list, out of the rows this transporter has on the tab. They should
            // be the same number; "4 of 29" means some rows were added AFTER the codes were set
            // (they are blank, and the grid behind this one shows them "Not defined"). The feed
            // still resolves - the server unions a transporter's rows - but the state is shown
            // rather than hidden, because one save of this transporter puts every row back in
            // step. Flagged by the server as `inconsistent`, not re-derived here.
            { headerName: "Rows", field: "row_count", width: 96, filter: false, resizable: true,
              headerTooltip: "How many transporter rows on this tab carry this list - one per "
                           + "state / vehicle type. A save writes to all of them. 'n of m' means "
                           + "some rows have no codes yet; saving this transporter fixes them.",
              cellRenderer: function (p) {
                  var d = p.data || {};
                  var total = d.row_count || 0;
                  if (!d.inconsistent) { return String(total); }
                  var withCodes = (d.rows_with_codes === undefined) ? 0 : d.rows_with_codes;
                  return '<span style="color:#b45309" title="'
                       + (total - withCodes) + ' row(s) of this transporter carry no child codes '
                       + '- save this transporter to write the list to all of them">'
                       + withCodes + ' of ' + total + '</span>';
              } },
            { headerName: "", width: 90, pinned: "right", filter: false, sortable: false,
              hide: readOnly,
              cellRenderer: function () {
                  return '<i class="icofont icofont-edit" style="color:#1976d2;cursor:pointer" title="Edit child codes"></i>';
              },
              onCellClicked: function (e) {
                  if (!e || !e.data || readOnly) { return; }
                  self.setState({ editing: e.data, draft: (e.data.child_codes || []).slice(),
                                  typed: "" });
              } }
        ];
    }

    renderEditDialog() {
        var row = this.state.editing;
        if (!row) { return null; }
        var self = this;
        return (
            <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                          background: "rgba(0,0,0,0.45)", zIndex: 1230, display: "flex",
                          alignItems: "center", justifyContent: "center" }}
                 onClick={() => this.setState({ editing: null, draft: [], typed: "" })}>
                <div style={{ background: "#fff", borderRadius: "10px", width: "min(540px, 94vw)",
                              display: "flex", flexDirection: "column" }}
                     onClick={(e) => e.stopPropagation()}>
                    <div className="slider-header" style={{ borderRadius: "10px 10px 0 0" }}>
                        {row.transporter_name || row.transporter_code}
                        <span style={{ cursor: "pointer" }}
                              onClick={() => this.setState({ editing: null, draft: [], typed: "" })}>✕</span>
                    </div>
                    <div style={{ padding: "16px 20px" }}>
                        <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "8px" }}>
                            Parent code <b>{row.transporter_code}</b> &middot; {row.row_count || 0} row(s)
                            on this tab
                        </div>
                        <label className="m-0" style={{ fontSize: "13px" }}>
                            Transporter child codes <span className="text-danger">*</span>
                            <i className="icofont icofont-info-circle"
                               title="The codes MSIL's dispatch feed reports this transporter under.
                                      A dispatch carrying one of them is credited to this transporter.
                                      Type a code and press Enter, or paste a list."
                               style={{ marginLeft: "6px", color: "#1976d2", cursor: "help" }}></i>
                        </label>
                        <CreatableSelect
                            isMulti
                            className="mt-2 mb-1"
                            classNamePrefix="react-select"
                            placeholder="Type a child code and press Enter"
                            menuIsOpen={false}
                            isClearable={false}
                            components={{ DropdownIndicator: null }}
                            inputValue={this.state.typed}
                            onInputChange={(text) => this.setState({ typed: text })}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === "Tab" || e.key === ",") {
                                    if (self.commitTyped()) { e.preventDefault(); }
                                }
                            }}
                            onBlur={() => this.commitTyped()}
                            value={(this.state.draft || []).map(function (c) {
                                return { value: c, label: c };
                            })}
                            onChange={(picked) => this.setState({
                                draft: (picked || []).map(function (o) { return o.value; })
                            })}
                            onPaste={(e) => {
                                var text = (e.clipboardData || window.clipboardData).getData("text");
                                if (!text) { return; }
                                e.preventDefault();
                                this.setState({ draft: mergeCodes(this.state.draft, text), typed: "" });
                            }} />
                        <small className="text-muted" style={{ fontSize: "11px" }}>
                            Saving writes this list to every row of this transporter on this tab, for
                            this warehouse. At least one code is required - a transporter with none
                            cannot be recognised in the MSIL feed at all.
                        </small>
                    </div>
                    <div className="slider-footer" style={{ borderRadius: "0 0 10px 10px", gap: "8px",
                                                            alignItems: "center" }}>
                        {[{ key: "cancel", label: "Cancel", bg: "#e2e8f0", fg: "#334e68",
                            onClick: () => self.setState({ editing: null, draft: [], typed: "" }) },
                          { key: "save", label: "Save", bg: "#28a745", fg: "#fff",
                            onClick: () => self.saveRow() }
                        ].map(function (b) {
                            return (
                                <button type="button" key={b.key} onClick={b.onClick}
                                        style={{ background: b.bg, color: b.fg, border: "none",
                                                 height: "34px", minWidth: "96px", padding: "0 16px",
                                                 fontSize: "13px", fontWeight: 600, lineHeight: "34px",
                                                 borderRadius: "6px", cursor: "pointer", margin: 0,
                                                 display: "inline-flex", alignItems: "center",
                                                 justifyContent: "center", boxSizing: "border-box" }}>
                                    {b.label}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.open) { return null; }
        var rows = this.state.rows || [];
        var withCodes = rows.filter(function (r) { return (r.child_codes || []).length > 0; }).length;
        return (
            <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                          background: "rgba(0,0,0,0.45)", zIndex: 1210, display: "flex",
                          alignItems: "center", justifyContent: "center" }}
                 onClick={() => { if (this.props.onClose) { this.props.onClose(); } }}>
                <div style={{ background: "#fff", borderRadius: "10px", width: "min(900px, 95vw)",
                              height: "min(700px, 90vh)", display: "flex", flexDirection: "column" }}
                     onClick={(e) => e.stopPropagation()}>
                    {/* Wrapped so a multi-line message (the clash list) keeps its line breaks -
                        the title is rendered as HTML, where a bare "\n" collapses to a space and
                        the per-code detail runs together into one unreadable paragraph. */}
                    <SweetAlert show={this.state.show} type={this.state.basicType}
                                title={<span style={{ whiteSpace: "pre-line" }}>{this.state.basicTitle}</span>}
                                onConfirm={() => this.setState({ show: false })} />
                    <div className="slider-header" style={{ borderRadius: "10px 10px 0 0" }}>
                        Transporter child codes
                        {this.props.tabLabel ? " - " + this.props.tabLabel : ""}
                        <span style={{ cursor: "pointer" }}
                              onClick={() => { if (this.props.onClose) { this.props.onClose(); } }}>✕</span>
                    </div>
                    <div style={{ padding: "12px 20px 8px 20px", fontSize: "11.5px", color: "#64748b" }}>
                        The codes MSIL's dispatch feed reports each transporter under. They are held
                        once per transporter, for this tab and warehouse, and the Actual SOB
                        configuration picks from this list. {withCodes} of {rows.length} transporters
                        have codes.
                    </div>
                    <div className="ag-theme-balham" style={{ flex: 1, minHeight: 0, margin: "0 20px 12px 20px" }}>
                        <AgGridReact
                            modules={AllModules}
                            columnDefs={this.columnDefs()}
                            rowData={rows}
                            defaultColDef={{ sortable: true, filter: true, resizable: true }}
                            enableBrowserTooltips={true}
                            pagination={true}
                            paginationPageSize={20}
                            suppressRowClickSelection={true} />
                    </div>
                    <div className="slider-footer" style={{ borderRadius: "0 0 10px 10px" }}>
                        <button type="button"
                                onClick={() => { if (this.props.onClose) { this.props.onClose(); } }}
                                style={{ background: "#e2e8f0", color: "#334e68", border: "none",
                                         height: "34px", minWidth: "96px", padding: "0 16px",
                                         fontSize: "13px", fontWeight: 600, borderRadius: "6px",
                                         cursor: "pointer", margin: 0 }}>
                            Close
                        </button>
                    </div>
                    {this.renderEditDialog()}
                    <div className={"dataLoadpage " + this.state.loadshow}
                         style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                                  zIndex: 1215 }}></div>
                    <div className={"dataLoadpageimg " + this.state.loadshow}
                         style={{ position: "fixed", top: "40%", left: "45%", zIndex: 1216 }}>
                        <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                    </div>
                </div>
            </div>
        );
    }
}
